import React, { useCallback, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import StyledCalendar from '../../../../../shared/components/v3/StyledCalendar/StyledCalendar';
import { ISelectChallengeDatesProps } from '../../../../../shared/interfaces/challenges';
import { formatDateYYYYMMDDTT } from '../../../../../shared/utils/datetime/datetime';

type DateRange = {
  start: string | null;
  end: string | null;
};

const SelectChallengeDates = ({ challenge, updateChallenge, setStepReady }: ISelectChallengeDatesProps) => {
  const [selectedRange, setSelectedRange] = useState<DateRange>({
    start: formatDateYYYYMMDDTT(new Date()),
    end: challenge.endAt || null
  });

  const { i18n } = useTranslation();

  const callUpdateChallenge = useCallback(() => {
    const startDate = formatDateYYYYMMDDTT(new Date());
    const endDate = selectedRange.end;
    updateChallenge({
      startAt: startDate ?? '',
      endAt: endDate ?? ''
    });
    setStepReady(!!startDate && !!endDate);
  }, [selectedRange.end]);

  useEffect(() => {
    callUpdateChallenge();
  }, [selectedRange, callUpdateChallenge]);

  return <StyledCalendar selectedRange={selectedRange} setSelectedRange={setSelectedRange} locale={i18n.language} />;
};

export default React.memo(SelectChallengeDates);
